import React from 'react';
import { Text } from '../Typography';

interface ChatListItemProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  isSelected?: boolean;
  onClick?: () => void;
  avatarContent?: React.ReactNode;
}

export const ChatListItem: React.FC<ChatListItemProps> = ({
  title,
  subtitle,
  isSelected = false,
  onClick,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full h-[44px] flex items-center gap-[8px] px-4  
        ${
          isSelected
            ? 'bg-positive-primary hover:bg-positive-hover bg-positive-hovery hover:bg-positive-primar'
            : 'hover:bg-grey-light hover:dark:bg-grey-main'
        }`}
    >
      <div className="w-[32px] h-[32px] flex items-center justify-center">
        <div className="w-[28px] h-[28px] rounded-full bg-positive-primary flex items-center justify-center">
          <span className="text-[12px] font-medium text-white">
            {title.charAt(0).toUpperCase()}
          </span>
        </div>
      </div>
      <div className="flex-1 text-left min-w-0">
        <Text
          variant="text-md-regular"
          className={`${isSelected ? 'text-white' : 'text-grey-black dark:text-grey-plain'} truncate block`}
        >
          {title}
        </Text>
        {subtitle && (
          <Text
            variant="text-sm-regular"
            className={`${isSelected ? 'text-positive-subtitle' : 'text-grey-hover dark:text-grey-hover-dark'} truncate block`}
          >
            {subtitle}
          </Text>
        )}
      </div>
    </button>
  );
};
